<template>
    <!-- 贷款问答 -->
    <div class="loan-q-a">
            <div>
                <ul>
                  <li class="q-a">
                    <img class="imgIcon" src="../assets/img/wenda.png" alt="图片不存在">
                    <span class="q-a-font">贷款问答</span>
                  </li>

                  <li class="arrowhead" >
                    <img v-if="!this.leftView" class="arrowheadLeft" src="../assets/img/wenda_z.png" alt="图片不存在">
                    <img v-if="this.leftView" @click="PreviousPage" class="arrowheadLeft" src="../assets/img/wenda_z_s.png" alt="图片不存在">
                    <img v-if="!this.rightView" class="arrowheadRight" src="../assets/img/wenda_y.png" alt="">
                    <img v-if="this.rightView"  @click="nextPage" class="arrowheadRight" src="../assets/img/wenda_y_s.png" alt="">
                  </li>
                </ul>
            </div>
            <div class="box">
                <ul>
                  <li v-for="item in questions" >
                    <div class="questionBox">
                      <span class="questionIcon text-center">问</span>
                      <span class="question">
                        {{ item.title }}
                        <br><br>
                      </span>
                    </div>
                    
                    <div class="answerBox">
                      <span class="answerIcon text-center">答</span>
                      <span class="answer">
                        {{ item.answer.length>180?item.answer.substring(0,180)+" ... ":item.answer}}
                        <a v-show="item.answer.length>180">查看详情</a>
                      </span>
                    </div>
                  </li>
                </ul>

            </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import config from '../../config/ipConfig'
    export default{
        name:"LoanInterlocution",

        data() {
            return {
              page: 1,
              pageNum:1,
              PageSize:3,
              msg:'',
              questions:[{
                id:1,
                title:"",
                answer:"",
                createTime:"",
                author:""
              }],
              total:0,
              apiUrl : config.apiUrl,
            }
        },
        computed:{
            totalPage:{
              get(){
                if(this.total%this.PageSize==0){
                  return this.total/this.PageSize
                }
                return this.total/this.PageSize+1;
              },
              
              
            },
            leftView(){
              if(this.pageNum>1){
                return true;
              }
              return false;
            },
            rightView(){
              if(this.pageNum < parseInt(this.totalPage)){
                return true;
              }
              return false;
            }
          
        },

        mounted(){
            this.questionList();

        },

        methods: {
            //查询数据
            questionList(){ 
                axios.get(this.apiUrl+'/index/loanquestion/page?limit=3&page='+this.page).then(
                    response => {
                        //console.log(response.data.data)
                        this.questions=response.data.data.list;
                        this.total  = response.data.data.total;
                    }
                    
                )  
            },

            nextPage(){
              this.pageNum++
              this.page++;
              this.questionList();
              console.log(this.leftView,this.rightView);
              console.log(this.totalPage);
            },
            PreviousPage(){
              this.pageNum--;
              this.page--;
              this.questionList();
            }
        },
    }
</script>

<style scoped>
.loan-q-a{
    width: 1920px;
    height: 700px;
    background-image: url("../assets/img/wendabg.jpg");
    padding: 72px 360px;
}
.loan-q-a .q-a{
    font-size:0;
    float: left;
}
.loan-q-a .imgIcon{
    float: left;
}
.loan-q-a .q-a-font{
    margin-left: 30px;
    color: #f8f8f8;
    font-size: 30px;
    font-weight: 700;
    line-height: 30px;
}
.loan-q-a .arrowhead{
    float: right;
    margin-right: 10px;

}
.loan-q-a .arrowhead .arrowheadRight{
    margin-left: 46px;
}
.loan-q-a .box{
    margin-top: 90px;
   
}
.loan-q-a .box li{
    width: 375px;
    height: 420px;
    float: left;
    background-color: #fff;
    margin-right: 25px;
    padding: 40px 20px 0px 20px;
}
.loan-q-a .box li .questionIcon{
    display: block;
    width: 20px;
    height: 20px;
    line-height: 20px;
    float: left;
    background-color: #525459;
    color: #fff;
}
.loan-q-a .box li .question{
    width: 289px;
    display: block;
    float: left;
    color: #17171a;
    font-size: 18px;
    font-weight: 700;
    /* line-height: 20px; */
    margin-left: 17px;
    
    
}
.loan-q-a .box li .answerIcon{
    display: block;
    width: 20px;
    height: 20px;
    line-height: 20px;
    float: left;
    background-color: #4a6fb5;
    color: #fff;
}
.loan-q-a .box li .answer{
    width: 289px;
    display: block;
    line-height: 25px; 
    color: #4f535e;
    float: left; 
    margin-left: 17px;  
}
</style>


// WEBPACK FOOTER //
// src/components/LoanInterlocution.vue